import useIsMobile from '@/hooks/use-is-mobile';
import { IconEdit, Link } from '@cmpsr/components';
import { Link as ReactRouterLink } from 'react-router-dom';

type EditLinkProps = {
  route: string;
};

export default function EditLink({ route }: EditLinkProps) {
  const isMobile = useIsMobile();
  const size = isMobile ? 's' : 'm';

  return (
    <Link as={ReactRouterLink} to={route} variant="link-secondary" size={size} trailingIcon={<IconEdit />}>
      Edit
    </Link>
  );
}
